import React, { useState, useContext } from "react";
import { Link, Redirect } from "react-router-dom";
import "./login.css";

import { AuthContext } from "../Context/auth";
import { auth, db } from "../Config/firebase";
import { signInWithEmailAndPassword, signOut, updatePassword } from "firebase/auth";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { isSuperadminEmail } from "../Utils/tenant";
import { LOGO_AUTENTICACAO, NOME_PLATAFORMA } from "../Config/branding";

const SENHA_PROVISORIA = "qualinfra";

function Login() {
const autoLogin = process.env.REACT_APP_DEV_AUTOLOGIN === "true";

const [email, setEmail] = useState(
  autoLogin ? process.env.REACT_APP_DEV_EMAIL || "" : ""
);

const [senha, setSenha] = useState(
  autoLogin ? process.env.REACT_APP_DEV_PASSWORD || "" : ""
);
const [mostrarSenha, setMostrarSenha] = useState(false);

  const [erro, setErro] = useState("");
  const [rota, setRota] = useState("");
  const [trocaObrigatoria, setTrocaObrigatoria] = useState(false);
  const [rotaAposTroca, setRotaAposTroca] = useState("/dashboard");
const [novaSenha, setNovaSenha] = useState("");
const [confirmacaoSenha, setConfirmacaoSenha] = useState("");
const [mostrarNovaSenha, setMostrarNovaSenha] = useState(false);
const [erroTrocaSenha, setErroTrocaSenha] = useState("");
  const [salvandoSenha, setSalvandoSenha] = useState(false);

  const { setLogado } = useContext(AuthContext);

  async function LoginUsuario() {
    try {
      setErro("");
      sessionStorage.removeItem("aviso_mensalidade");

      const userCred = await signInWithEmailAndPassword(
        auth,
        email.trim(),
        senha
      );

      const uid = userCred.user.uid;
      const tokenResult = await userCred.user.getIdTokenResult();
      const demonstracaoExpiraEm = Number(tokenResult.claims.demonstracaoExpiraEm || 0);

      if (tokenResult.claims.demonstracao === true && Date.now() >= demonstracaoExpiraEm) {
        await signOut(auth);
        localStorage.clear();
        setLogado(false);
        setRota("/adquirir-plano");
        return;
      }

      const assinaturaExpiraEm = Number(tokenResult.claims.assinaturaExpiraEm || 0);
      if (["mensal", "anual"].includes(tokenResult.claims.plano) && assinaturaExpiraEm) {
        const diasRestantes = Math.ceil(
          (assinaturaExpiraEm - Date.now()) / (24 * 60 * 60 * 1000)
        );
        if (diasRestantes <= 5) {
          sessionStorage.setItem("aviso_mensalidade", JSON.stringify({
            diasRestantes,
            assinaturaExpiraEm,
            cicloCobranca: tokenResult.claims.cicloCobranca || tokenResult.claims.plano,
          }));
        }
      }

      const userRef = doc(db, "users", uid);
      const userSnap = await getDoc(userRef);

      if (!userSnap.exists()) {
        throw new Error("USUARIO_SEM_PERFIL");
      }

      const dadosUsuario = userSnap.data();
      const { tipo, ativo, tenantId: tenantIdPerfil } = dadosUsuario;
      const tenantIdToken = String(tokenResult.claims?.tenantId || "").trim();
      const tenantId = String(tenantIdPerfil || tenantIdToken || "").trim();
      const planoUsuario = String(dadosUsuario.plano || tokenResult.claims?.plano || "").trim().toLowerCase();
      let adminPrincipal = tipo === "admin" && dadosUsuario.adminPrincipal === true;
      if (tipo === "admin" && tenantId) {
        try {
          const tenantSnap = await getDoc(doc(db, "tenants", tenantId));
          const adminPrincipalId = tenantSnap.exists() ? tenantSnap.data()?.adminPrincipalId || "" : "";
          if (adminPrincipalId) adminPrincipal = adminPrincipalId === uid;
        } catch (tenantError) {
          console.warn("Não foi possível confirmar o administrador principal:", tenantError);
        }
      }

      if (!ativo) {
        throw new Error("USUARIO_INATIVO");
      }

      localStorage.setItem("tipoUsuario", tipo);
      localStorage.setItem("tenantId", tenantId || "");
      localStorage.setItem("planoUsuario", planoUsuario);
      localStorage.setItem("adminPrincipal", adminPrincipal ? "S" : "N");
      localStorage.setItem("superadmin", isSuperadminEmail(userCred.user.email) ? "S" : "N");

      if (dadosUsuario.senhaTemporaria === true || senha === SENHA_PROVISORIA) {
        setRotaAposTroca(
          isSuperadminEmail(userCred.user.email)
            ? "/app/cadastrousuarios"
            : tipo === "cliente"
              ? "/app/laudos"
              : "/dashboard"
        );
        setNovaSenha("");
        setConfirmacaoSenha("");
        setMostrarNovaSenha(false);
        setErroTrocaSenha("");
        setTrocaObrigatoria(true);
        return;
      }

      // 🔐 Persistência
      localStorage.setItem("logado", "S");
      localStorage.setItem("tipoUsuario", tipo);
      localStorage.setItem("tenantId", tenantId || "");
      localStorage.setItem("planoUsuario", planoUsuario);
      localStorage.setItem("adminPrincipal", adminPrincipal ? "S" : "N");
      localStorage.setItem("superadmin", isSuperadminEmail(userCred.user.email) ? "S" : "N");
      localStorage.removeItem("logoRelatorioUrl");
      if (tenantId) {
        localStorage.removeItem(`logoSistemaUrl:${tenantId}`);
        try {
          const brandingSnap = await getDoc(doc(db, "tenant_branding", tenantId));
          const logoRelatorioUrl = brandingSnap.exists() ? brandingSnap.data()?.logoUrl || "" : "";
          if (logoRelatorioUrl) {
            localStorage.setItem("logoRelatorioUrl", logoRelatorioUrl);
            localStorage.setItem(`logoSistemaUrl:${tenantId}`, logoRelatorioUrl);
          }
        } catch (brandingError) {
          console.warn("Logo personalizada ainda não disponível:", brandingError);
        }
      }
      sessionStorage.removeItem("pesquisa_pendente_exibida_sessao");
      sessionStorage.setItem("pesquisa_pendente_verificar_login", "1");

      setLogado(true);

      /* =========================
         REDIRECIONAMENTO POR TIPO
         (CORRIGIDO)
      ========================= */
      if (isSuperadminEmail(userCred.user.email)) {
        setRota("/app/cadastrousuarios");
      } else if (tipo === "cliente") {
        setRota("/app/laudos");
      } else if (tipo === "colaborador") {
        setRota("/dashboard");
      } else {
        // admin
        setRota("/dashboard");
      }

    } catch (err) {
      console.error(err);

      localStorage.clear();
      setLogado(false);

      if (err.message === "USUARIO_SEM_PERFIL") {
        setErro("Usuário não autorizado.");
      } else if (err.message === "USUARIO_INATIVO") {
        setErro("Usuário inativo. Consulte o administrador do sistema!");
      } else {
        setErro("E-mail ou senha inválidos.");
      }
    }
  }

  async function salvarNovaSenha() {
    if (novaSenha.length < 6) {
      setErroTrocaSenha("A nova senha deve ter pelo menos 6 caracteres.");
      return;
    }
    if (novaSenha === SENHA_PROVISORIA) {
      setErroTrocaSenha("Escolha uma senha diferente da senha provisória.");
      return;
    }
    if (novaSenha !== confirmacaoSenha) {
      setErroTrocaSenha("As senhas informadas não coincidem.");
      return;
    }

    setSalvandoSenha(true);
    setErroTrocaSenha("");
    try {
      await updatePassword(auth.currentUser, novaSenha);
      await updateDoc(doc(db, "users", auth.currentUser.uid), { senhaTemporaria: false });
      setTrocaObrigatoria(false);
      setLogado(true);
      setRota(rotaAposTroca);
    } catch (err) {
      console.error(err);
      setErroTrocaSenha("Não foi possível alterar a senha. Faça login novamente e tente de novo.");
    } finally {
      setSalvandoSenha(false);
    }
  }

  async function cancelarTrocaSenha() {
    await signOut(auth);
    localStorage.clear();
    sessionStorage.clear();
    setLogado(false);
    setTrocaObrigatoria(false);
    setRota("/");
  }

  if (rota) {
    return <Redirect to={rota} />;
  }

  return (
  <div
    className="login-page"
    style={{
      backgroundImage: `url(${process.env.PUBLIC_URL}/Images/paginafundologin.jpg)`,
    }}
  >
    <div className="login-card">
      <form className="form-signin">
        <img
          src={LOGO_AUTENTICACAO}
          className="login-logo"
          alt={NOME_PLATAFORMA}
        />

        <h1 className="login-title">Acesso ao Sistema</h1>
        <p className="login-subtitle">
          Sistema de Gestão da Qualidade
        </p>

        <input
          className="form-control"
          type="email"
          placeholder="E-mail"
          value={email}
          onChange={e => setEmail(e.target.value)}
        />

        <input
          className="form-control"
          type={mostrarSenha ? "text" : "password"}
          placeholder="Senha"
          value={senha}
          onChange={e => setSenha(e.target.value)}
          onKeyDown={e => e.key === "Enter" && LoginUsuario()}
        />

        <div className="form-check text-start mt-2 mb-2">
          <input
            className="form-check-input"
            type="checkbox"
            id="mostrar-senha-login"
            checked={mostrarSenha}
            onChange={e => setMostrarSenha(e.target.checked)}
          />
          <label className="form-check-label" htmlFor="mostrar-senha-login">
            Mostrar senha
          </label>
        </div>

        <button
          type="button"
          className="btn btn-primary btn-login"
          onClick={LoginUsuario}
        >
          Acessar
        </button>

        {erro && (
          <div className="alert alert-danger mt-3">
            {erro}
          </div>
        )}

<div className="login-links mt-4">
  <Link to="/app/resetsenha">Esqueci minha senha</Link>
  <span className="mx-2 text-muted">|</span>
  <Link to="/">Página principal</Link>
</div>

      </form>
    </div>
    {trocaObrigatoria && (
      <div className="modal d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: "rgba(0, 0, 0, 0.55)" }}>
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header"><h5 className="modal-title">Cadastre uma nova senha</h5></div>
            <div className="modal-body">
              <p>Por segurança, altere a senha provisória antes de acessar o sistema.</p>
              <input className="form-control mb-2" type={mostrarNovaSenha ? "text" : "password"} placeholder="Nova senha" value={novaSenha} onChange={(event) => setNovaSenha(event.target.value)} autoFocus />
              <input className="form-control" type={mostrarNovaSenha ? "text" : "password"} placeholder="Confirme a nova senha" value={confirmacaoSenha} onChange={(event) => setConfirmacaoSenha(event.target.value)} onKeyDown={(event) => event.key === "Enter" && salvarNovaSenha()} />
              <div className="form-check mt-2">
                <input className="form-check-input" type="checkbox" id="mostrar-nova-senha" checked={mostrarNovaSenha} onChange={(event) => setMostrarNovaSenha(event.target.checked)} />
                <label className="form-check-label" htmlFor="mostrar-nova-senha">Mostrar senha</label>
              </div>
              {erroTrocaSenha && <div className="alert alert-danger mt-3 mb-0">{erroTrocaSenha}</div>}
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-outline-secondary" onClick={cancelarTrocaSenha} disabled={salvandoSenha}>Cancelar e sair</button>
              <button type="button" className="btn btn-primary" onClick={salvarNovaSenha} disabled={salvandoSenha}>{salvandoSenha ? "Salvando..." : "Salvar nova senha"}</button>
            </div>
          </div>
        </div>
      </div>
    )}
  </div>
);

}

export default Login;
